/**
 * NoticeList
 * --
 */
import { useState, useEffect } from 'react';
import { Content, Title } from 'components';
import { Button, Table, Spin } from 'antd';
import { ExportOutlined } from '@ant-design/icons';
import MessageAlert, { strCut } from 'utils';
import moment from 'moment';
import { NoticeApi } from 'api';

/**----------------------------------------
 * [Component] 홈 > 매장별 매출 차트
 * ----------------------------------------
 */
const NoticeList = ({ permission, shopType }) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [loading, setLoading] = useState(false);
  const [noticeList, setNoticeList] = useState([]);
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /**--------------------
   * 공지사항 조회
   * --------------------
   */
  const getNoticeList = async () => {
    try {
      const { status, message, data } = await NoticeApi.getNotices();
      if (status !== 200) throw { message };
      setNoticeList(data);
    } catch (e) {
      MessageAlert.error(e.message);
    }
  };

  console.log('shopType =====>', shopType);

  /* ===== HOOKS ===== */
  useEffect(() => {
    getNoticeList();
  }, []);

  /* ===== RENDER ===== */
  // JSX: start
  return (
    <>
      <Spin spinning={loading}>
        <Content
          maxWidth={'100%'}
          height={320}
          borderRadius={4}
          // padding={'14px 5px'}
        >
          <Title
            size={5}
            style={{ marginBottom: 12 }}
            subButton={
              !shopType ? (
                <Button
                  size="small"
                  onClick={() => window.open('/notice/list', '_blank')}
                >
                  <ExportOutlined /> 공지관리
                </Button>
              ) : null
            }
          >
            공지사항
          </Title>

          <Table
            bordered
            size="small"
            scroll={{ x: 'max-content', y: 210 }}
            // style={{ height: 300 }}
            pagination={false}
            dataSource={noticeList.slice(0, 5) ?? []}
            columns={[
              {
                title: '등록일(시간)',
                dataIndex: 'created_at',
                width: 200,
                align: 'center',
                render: (v) => moment(v * 1000).format('YYYY-MM-DD (HH:mm:ss)'),
              },
              {
                title: '공지사항',
                dataIndex: 'notice_name',
                // width: 220,
                align: 'center',
                render: (v) => strCut(v, 100),
              },
              ...(permission === 'ADMIN'
                ? [
                    ({
                      title: '대상',
                      dataIndex: 'show_target',
                      width: 125,
                      align: 'center',
                      render: (value) =>
                        value === 'ADMIN' ? '관리자' : '전체',
                    },
                    {
                      title: '노출',
                      dataIndex: 'is_show',
                      width: 125,
                      align: 'center',
                      render: (value) => (value === 'Y' ? '노출됨' : '미노출'),
                    }),
                  ]
                : []),
            ]}
          />
        </Content>
      </Spin>
    </>
  ); // JSX: end
};

NoticeList.defaultProps = {
  onSelect: () => {},
};
export default NoticeList;
